import { GridColDef } from '@mui/x-data-grid-premium'
import { useTranslation } from 'react-i18next'
import { useColumnConfig } from '@omnea-app/fe-tables/columns/useColumnConfig'
import { applyDefaultColumnDefinitionsToColumns } from '@omnea-app/fe-tables/utils/columnDefaults'

interface RfxColumnsConfigs {
  sortable?: boolean
}

export type RfxRow = {
  id: string // Required by DataGrid, corresponds to requestId
  requestId: string
  requestName: string
  status: 'SETUP' | 'COLLECT_RESPONSES' | 'RESPONSES_CLOSED' | 'SCORE_RESPONSES' | 'PICK_SUPPLIER' | 'COMPLETE'
  createdAt: string
  dueDate: string
}

export const useRfxColumns = ({ sortable = true }: RfxColumnsConfigs): GridColDef<RfxRow>[] => {
  const { t } = useTranslation('dashboard', { keyPrefix: 'rfx-section' })

  const defaultColumns = useColumnConfig<RfxRow>({
    hasSupplierColumn: false,
    columnConfig: [
      {
        field: 'requestName',
        headerName: t('table.name'),
        hideable: false,
        sortable,
        columnType: 'text',
      },
      {
        field: 'status',
        columnType: 'chip-single',
        sortable,
        headerName: t('table.status'),
        valueGetter: (_, row) => t(`table.statuses.${row.status}`),
      },
      {
        columnType: 'date',
        field: 'dueDate',
        sortable,
        headerName: t('table.dueDate'),
      },
    ],
  })

  return applyDefaultColumnDefinitionsToColumns(defaultColumns)
}
